<template>
    <v-card>
        <v-data-table
            :items="unit.nhvasHistory"
            :headers="headers"
            :options.sync="options"
            hide-default-footer
        >
            <template v-slot:item="items">
                <tr>
                    <td>{{items.item.startDate | formatDate }}</td>
                    <td>{{items.item.endDate | formatDate }}</td>
                    <td>{{items.item.isNhvasMaintenanceAccredited}}</td>
                </tr>
            </template>
        </v-data-table>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px" persistent>
                <Form v-model="model" @close="dialog = false">
                    <template v-slot:header>
                        <v-spacer></v-spacer>
                        <v-btn @click="dialog=false" icon text>
                            <v-icon>close</v-icon>
                        </v-btn>
                    </template>
                </Form>
            </v-dialog>
        </v-card-actions>
    </v-card>
</template>
<script>
import GarageLocationsClient from '@/components/GarageLocations/GarageLocationsClient.vue';

export default {
    mixins: [GarageLocationsClient],
    props: {
        unit: {
            required: true
        }
    },
    data() {
        return {
            dialog: false,
            model: {},
            options: {
                sortBy: ['startDate', 'endDate']
            },
            headers: [
                { text: 'Start Date', value: 'startDate', sortable: false },
                { text: 'End Date', value: 'endDate', sortable: false },
                { text: 'Maintenance Accredited?', value: 'isNhvasMaintenanceAccredited', sortable: false }
            ]
        };
    },
    methods: {
        closeDialog() {
            this.dialog = false;
        }
    },
};
</script>
